import { loadable } from '@change-corgi/core-react/loadable';

import type { AppRoute } from '#src/shared/routes';

import { Loading } from '#src/app/shared/routes';

import { resolveTopicL10nForBotsFromSlugParam } from './shared/resolveTopicL10nForBotsFromSlugParam';

export const ROUTES: readonly AppRoute[] = [
	{
		id: 'topic',
		path: '/topic/:slug',
		component: loadable(async () => import(/* webpackChunkName: "pages/topic-details" */ '../index'), {
			exportName: 'Topic',
			fallback: Loading,
		}),
		frame: true,
		ssr: {
			enabled: true,
			seo: true,
			resolveL10n: resolveTopicL10nForBotsFromSlugParam,
		},
	},
];
